export default "\n# 致谢\n\n感谢您花时间阅读我的简历，期待能有机会和您共事。\n\n"